import React from 'react';

import { FormSection } from 'redux-form';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';

import * as validator from 'helpers/Validator';

class RentalHistoryQuestions extends React.Component {
  render() {
    return (
      <FormSection name="rental_history_questions">
        <div className="row" style={{ marginBottom: '25px', textAlign: 'center' }}>
          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
            Has the applicant ever been evicted from a tenancy or left owing money?
          </h5>
          <BooleanRadioButtons
            name="eviction"
            style={{ width: '140px', display: 'inline-flex' }}
            validate={[validator.required]}
          />

          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
            Has the applicant ever been part of a landlord/tenant hearing?
          </h5>
          <BooleanRadioButtons
            name="court"
            style={{ width: '140px', display: 'inline-flex' }}
            validate={[validator.required]}
          />

          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
            Has the applicant ever been convicted of a crime or felony?
          </h5>
          <BooleanRadioButtons
            name="felony"
            style={{ width: '140px', display: 'inline-flex' }}
            validate={[validator.required]}
          />

          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
            Has the applicant ever declared personal bankruptcy?
          </h5>
          <BooleanRadioButtons
            name="bankruptcy"
            style={{ width: '140px', display: 'inline-flex' }}
            validate={[validator.required]}
          />

          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
            Has the applicant ever rented with you before?
          </h5>
          <BooleanRadioButtons
            name="has_previously_rented"
            style={{ width: '140px', display: 'inline-flex' }}
            validate={[validator.required]}
          />
        </div>
      </FormSection>
    );
  }
}
export default RentalHistoryQuestions;
